// Components==============
import {
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { Calendar } from 'react-calendar';
import './index.module.scss';
// =========================

export default function ToDate({ selectedEndDate, setSelectedEndDate }) {
    const [isEndOpen, setIsEndOpen] = useState(false);

    const handleEndSelect = (value) => {
        setSelectedEndDate(value);
    };

    // format date
    const formattedDate = (date) => {
        const d = new Date(date);
        const month = d.toLocaleString('nl-NL', { month: 'long' });
        const day = d.getDate();
        const year = d.getFullYear();
        return `${day} ${month} ${year}`;
    };

    const formatEndDate = (date) => {
        const d = new Date(date);
        return d;
    };

    useEffect(() => {
        setIsEndOpen(false);
    }, [selectedEndDate]);

    const framerArrow = {
        open: {
            rotate: 0,
        },
        closed: {
            rotate: 180,
        },
    };

    const framerOption = {
        visible: {
            opacity: 1,
        },
        hidden: {
            opacity: 0,
        },
    };

    return (
        <div styleName="dateRange">
            <h2 styleName="rangeHead ">Tot</h2>
            <div
                onClick={() => setIsEndOpen((prev) => !prev)}
                styleName="rangeDate"
            >
                <span>{formattedDate(selectedEndDate)}</span>
                <motion.div
                    animate={!isEndOpen ? 'open' : 'closed'}
                    variants={framerArrow}
                >
                    <FontAwesomeIcon
                        style={{ color: '#1E265C' }}
                        icon={faChevronDown}
                        styleName="chevron"
                    />
                </motion.div>
            </div>
            {isEndOpen && (
                <motion.div
                    variants={framerOption}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                >
                    <Calendar
                        styleName="react-calendar "
                        onChange={handleEndSelect}
                        value={formatEndDate(selectedEndDate)}
                        locale="nl-NL"
                        defaultView="year"
                        nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                        next2Label={
                            <FontAwesomeIcon icon={faChevronDoubleRight} />
                        }
                        prevLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                        prev2Label={
                            <FontAwesomeIcon icon={faChevronDoubleLeft} />
                        }
                        formatMonth={(locale, date) =>
                            date
                                .toLocaleString(locale, { month: 'long' })
                                .slice(0, 3)
                        }
                    />
                </motion.div>
            )}
        </div>
    );
}
